export default (routeName) => {
  switch (routeName) {
    case 'AdminUpload': return { name: 'Upload Images', code: 1 }
    case 'AdminDashboard': return { name: 'Dashboard', code: 2 }
    case 'AdminImageDrive': return { name: 'Images', code: 3 }
    case 'AdminServices': return { name: 'Services', code: 4 }
    case 'AdminFollowers': return { name: 'Followers', code: 5 }
    case 'AdminSupport': return { name: 'Support', code: 9 }
    case 'AdminSettingsGeneral': return { name: 'General Settings', code: 6 }
    case 'AdminSettingsMembers': return { name: 'Members', code: 7 }
    case 'AdminSettingsPolicies': return { name: 'Policies', code: 8 }
    default: return { name: 'Not Found!', code: -1 }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Matcher.js